; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ContentSearch/SearchResultsView',["jquery", "knockout", "eventManager", "score_ccf/moduleLoader", "score_bootstrap/Components/ContentSearch/SearchResultsView", "score_bootstrap/Components/ContentSearch/SearchResultsBase", "score_bootstrap/Models/Tile"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("knockout"), require("eventManager"), require("score_ccf/moduleLoader"), require("score_bootstrap/Components/ContentSearch/SearchResultsView"), require("score_bootstrap/Components/ContentSearch/SearchResultsBase"), require("score_bootstrap/Models/Tile")) :
            console && console.error('SearchResultsView does not support non-amd script loading.');
}(this/* window */, function ($, ko, eventManager, moduleLoader, ScoreSearchResultsView, SearchResultsBase, Tile) {

    var tileCache = {};

    function SearchResultsView(scope, uniqueId, tilesPerPage, tileName, qvTileName, showEvents, switchToClassicPager, classicPagesToDisplay, showEllipsisInBetween, scrollToPageTop) {
        // call the parent constructor
        ScoreSearchResultsView.apply(this, [].slice.call(arguments));

        this.totalItems = ko.observable(0);

        Object.defineProperties(this, {
            tilesPerPage: { enumerable: true, value: tilesPerPage }
        });

        tileCache[this.id] = {};
    }

    // inherit base class methods
    SearchResultsView.prototype = Object.create(ScoreSearchResultsView.prototype);


    // Override default appendTiles from SCORE
    /* We've overriden it to do the following:
        1. Disable automatic MatchHeight            
    */
    SearchResultsView.prototype.appendTiles = function appendTiles(response, isLoadMore) {

        // if the current search result is switched to a classic pager, we should clear results collection 
        // which used to render the result results, so it'll have just current page tiles.
        if (this.switchToClassicPager) {
            this.results.removeAll();
        }

        var newTiles = [], originalQuantity = this.tiles.length, lastRowTiles = [];

        if (isLoadMore) {
            lastRowTiles = SearchResultsBase.getLastRowTiles(this);
        }

        response.items.forEach(function (item) {
            var tileId = item.id.toString(), tile, cache = tileCache[this.id];

            if (!cache.hasOwnProperty(tileId)) {
                cache[tileId] = { item: item };
            }

            if (!cache[tileId].hasOwnProperty(this.tileName)) {
                cache[tileId][this.tileName] = new Tile(item, this.tileName);
            }

            tile = cache[tileId][this.tileName];
            this.results.push(tile);
            newTiles.push(tile.element());
        }, this);

        // store amount pages for a classic pager
        this.totalPages(response.totalPages);
        this.currentPage(response.page);
        this.allPages.removeAll();
        Array.apply(null, { length: response.totalPages }).map((function (v, i) { this.allPages.push(i); }).bind(this));
        this.showPager(response.totalPages > 1 && this.switchToClassicPager);

        this.totalItems(response.totalItems);
        this.overrideNumberOfResults();

        if (!newTiles.length) {
            // explicitly providing hook to tenants for actions when result is empty
            eventManager.trigger("search-empty");
            return [];
        }

        newTiles = $(newTiles).add(SearchResultsBase.injectPromoTiles(this, originalQuantity));

        if (this.initialResultLoaded && this.scrollToPageTop) {
            //for tabset scroll only to search results component which is visible/active
            if ($('.nav-tabs').length) {
                var _this = this;
                //$('.nav-tabs .active > a').each(function(index, elem) {
                var tabSetPanel = $($('.nav-tabs .active > a').attr('href'));
                var searchPanelId = "#" + $(_this.scope)[0].id;
                if (tabSetPanel.length && tabSetPanel.find(searchPanelId).length) {
                    SearchResultsBase.prototype.scrollToTopResults.call(this);
                }
                //});
            } else {
                SearchResultsBase.prototype.scrollToTopResults.call(this);
            }
        }

        // setup the initial release was loaded
        this.initialResultLoaded = !0;

        // explicitly providing hook to tenants for search rendering
        eventManager.trigger("search-rendered", this.scope, response.page | 0, response.perPage | 0, response.totalItems | 0, this.tileName);
        eventManager.trigger("RunEllipsisEvent", this.scope);

        return newTiles;
    };

    SearchResultsView.prototype.getPages = function getPages() {
        //console.log("classicPagesToDisplay", this.classicPagesToDisplay);
        //console.log('totalPages', this.totalPages());
        if (this.totalPages() <= this.classicPagesToDisplay || this.classicPagesToDisplay <= 0) {
            return this.allPages();
        } else {
            var first = 0;

            var upperLimit = this.currentPage() + Math.round((this.classicPagesToDisplay - 1) / 2);
            var downLimit = this.currentPage() - parseInt((this.classicPagesToDisplay - 1) / 2);

            while (upperLimit >= this.totalPages()) {
                upperLimit--;
                if (downLimit > first)
                    downLimit--;
            }

            while (downLimit < first) {
                downLimit++;
                if (upperLimit < this.totalPages())
                    upperLimit++;
            }

            var pages = [];
            for (var i = downLimit; i <= upperLimit; i++) {
                pages.push(i);
            }

            return ko.observableArray(pages);
        }
    };

    SearchResultsView.prototype.overrideNumberOfResults = function overrideNumberOfResults() {
        var $numberOfResults = $('.score-results-summary', $(this.scope).parents(".score-multi-view-search-results")[0]);

        var numOfResults = this.totalItems();
        var currentPage = this.currentPage();
        var numberPerPage = this.tilesPerPage;

        var firstResult =
            numOfResults === 0 ? 0 : currentPage * numberPerPage + 1;
        var lastResult = currentPage * numberPerPage + numberPerPage;
        //On the last page use the actual last results number instead of the calculated one
        lastResult = lastResult > numOfResults ? numOfResults : lastResult;

        var newMarkup =
            firstResult.toLocaleString() +
            "-" +
            lastResult.toLocaleString() +
            " of " +
            numOfResults.toLocaleString() +
            " Results";

        $numberOfResults.html(newMarkup);
        $numberOfResults.focus();
    };

    SearchResultsView.init = function initSearchResultsView(args) {
        return new SearchResultsView(
            args.scope,
            args.uniqueId,
            args.TilesPerPage,
            args.TileName,
            args.QuickViewTileName,
            args.ShowActionMessages || [],
            args.SwitchToClassicPager,
            args.ClassicPagerButtonsToDisplay,
            args.ShowPagerEllipsisInBetween,
            args.ScrollToPageTop);
    };

    return SearchResultsView;
}));
